import DataTable from 'libs/kd_data_table/data-table';

export default class extends DataTable {
  constructor(data) {
    const options = {
      dataset_name: 'lectures',

      table_properties: {
        name: 'InstructorSessionTable',
        creatable: { enabled: true },
        paginatable: { enabled: true },
        searchable: { enabled: true },
        timezone: data.timezone
      },

      columns: [
        {
          name: I18n.t('dict.table.order'),
          property: 'order',
          width: 'number_short',
          sortable: {
            type: 'number'
          }
        },

        {
          name: I18n.t('dict.table.session'),
          property: 'title',
          width: 'primary',
          hideable: false,
          editable: {
            type: 'text'
          },
          sortable: {
            type: 'string'
          }
        },

        {
          name: I18n.t('dict.table.visible_on'),
          property: 'visible_on_string',
          width: 'date_long',
          editable: {
            type: 'date'
          },
          sortable: {
            type: 'date',
            dragOverride: true
          }
        },

        {
          name: I18n.t('dict.table.created_at'),
          property: 'created_at',
          width: 'date_long',
          sortable: {
            type: 'date'
          }
        },

        {
          name: I18n.t('dict.table.meeting_start'),
          property: 'start_date_string',
          width: 'date_long',
          editable: {
            type: 'date'
          },
          sortable: {
            type: 'date'
          }
        },

        {
          name: I18n.t('dict.table.meeting_end'),
          property: 'end_date_string',
          width: 'date_long',
          editable: {
            type: 'date'
          },
          sortable: {
            type: 'date'
          }
        },

        {
          name: I18n.t('dict.table.status'),
          property: 'status',
          editable: {
            type: 'dropdown',
            dropdown_options: ['published', 'draft']
          },
          sortable: {
            type: 'string'
          }
        }
      ],

      column_properties: {
        hideable: { enabled: true },
        sortable: { enabled: true },
        editable: { enabled: true },
      },

      row_properties: {
        removable: { enabled: true },
        draggable: {
          enabled: true,
          update_url: data.sort_lectures_path
        },
        data_url: data.course_lectures_path,
        actions: 4
      }
    };

    // Cleaning data before sending to data table to init
    let cols = ['order','title','status', 'visible_on_string'];

    if (data.adaptive)
      cols = ['order', 'title', 'status','created_at'];

    if (!data.adaptive && Kadenze.isKannu)
      cols.push('start_date_string','end_date_string');

    options.columns = options.columns.filter(col => cols.includes(col.property));

    options.column_properties.hideable.default_columns = cols;

    options.date_cols = cols.filter(col => s.endsWith(col, '_string'));

    const el = document.getElementById('session_listing');

    super(data, el, options);

    this.course_id = document.getElementById('course_id').value

    this.bindData(data);
  }

  prepRowData(data){
    this.config.date_cols.forEach(date_field => {
      const value = ko.isObservable(data[date_field]) ?
        data[date_field]() :
        null;

      if (value == null)
        data[date_field] = ko.observable('');
    });
  }

  bindData(data) {
    this.adaptive = data.adaptive;
    this.sort_lectures_path = data.sort_lectures_path;
    this.new_lecture_path = data.new_lecture_path;
  }

  removeSession(session, evt) {
    const deletePrompt = I18n.t('session.delete_session_msg');
    session.removeRow(session, evt, deletePrompt);
  }

  copySession(session) {
    const copyPrompt = I18n.t('session.copy_session_msg');;
    session.copyRow(session, session.cloner_lectures_path(), copyPrompt);
  }

  previewSession(session) {
    const previewOptions = {
      preview: true,
      exit_path: encodeURI(window.location.pathname)
    };

    window.location = Kadenze.Routes.course_session_path(
      session.course_id(),
      session.id(),
      previewOptions
    );
  }

  cleanRowSortingData(row, arr){
    return { 'lectures': arr };
  }

  cleanRowEditingData(row, data) {
    const cleanedData = {};

    data.status = data.status.toLowerCase();

    this.config.date_cols.forEach(date_field => {
      data[date_field] = Kadenze.Util.getMomentDateFromObservable(row[date_field])
        .utc()
        .format(I18n.t('date.formats.js_default_with_zone'));
    });

    cleanedData.lecture = data;

    return cleanedData;
  }
}
